
<template>
  <div>
    <h6 class="font-bold mb-4">{{ filter.altLabel ? filter.altLabel : $t('filters.' + filter.title + '.title') }}</h6>
    <vs-select
        multiple
        color="success"
        style="width:100%;"
        class="selectExample"
        v-model="selected"
        :reduce="terms => terms.value" :options="filter.terms"
        >
        <div :key="index" v-for="(item,index) in options">
          <vs-select-group style="width:100%;height:100%;" :title="$t('filters.' + filter.title + '.values.' + item.title)" v-if="item.group">
            <vs-select-item :key="groupIndex" :value="groupItem.value" :text="groupItem.text" v-for="(groupItem, groupIndex) in item.group"/>
          </vs-select-group>
        </div>
    </vs-select>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  name: 'sm-hateoas-filter-sub-terms-select',
  components: {
    vSelect
  },
  props: {
    filter: {
      type: Object,
      default () {
        return {
          id: null,
          title: null,
          terms: []
        };
      }
    }
  },
  data () {
    const termGroups = new Set(this.filter.terms.map(t => t.term));
    const options = [];
    termGroups.forEach(element => {
      options.push({
        title: element,
        group: this.filter.terms.filter(t => t.selected && t.term === element).map(t => { return {text: t.label, value: t.value}; })
      });
    });
    return {
      index: 0,
      selected: this.filter.terms.filter(t => t.selected).map(t => t.value),
      options
    };
  },
  watch: {
    selected: {
      immediate: true,
      handler (value) {
        this.$emit('change', value);
      }
    }
  },
  methods: {
    isSelected (term) {
      return this.selected.indexOf(term.value) >= 0;
    }
  }
};
</script>

<style scoped>

</style>
